<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">适应行为评定量表第二版中文版统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">家长评-儿童版</span></div>
      </div>
      <div class="body">
        <div class="de" style="margin:0 0 40px 0;font-size: 14px">ps: <span style="color: #832C75">*</span>为必填项</div>
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="所在学校">
                <a-input class="cu-input1" v-model="formModel.parent.school_name"/>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="测试日期" prop="parent.test_date">
                  <a-date-picker style="width: 100%" class="cu-input1" @change="changeParentTestTime" format="YYYY-MM-DD" v-model="formModel.parent.test_date"/>
                </a-form-model-item>
              </a-col>
          </a-row>
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="学校类别" prop="parent.school_category">
                  <a-select placeholder="请选择" v-model="formModel.parent.school_category">
                    <a-select-option value="无">无</a-select-option>
                    <a-select-option value="普通高等学校">普通高等学校</a-select-option>
                    <a-select-option value="中等专业学校（中专）">中等专业学校（中专）</a-select-option>
                    <a-select-option value="职业高中（职高）">职业高中（职高）</a-select-option>
                    <a-select-option value="技工学校（技校）">技工学校（技校）</a-select-option>
                  </a-select>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="实际年龄" prop="parent.real_age">
                  <a-input class="cu-input1" disabled placeholder="选择测试日期后将自动计算" v-model="formModel.parent.real_age"/>
                </a-form-model-item>
              </a-col>
          </a-row>
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="所在年级" prop="parent.grade">
                <a-select placeholder="请选择" style="width: 100%" v-model="formModel.parent.grade">
                  <a-select-option value="无">无</a-select-option>
                  <a-select-option value="幼儿园大班">幼儿园大班</a-select-option>
                  <a-select-option value="小学一年级">小学一年级</a-select-option>
                  <a-select-option value="小学二年级">小学二年级</a-select-option>
                  <a-select-option value="小学三年级">小学三年级</a-select-option>
                  <a-select-option value="小学四年级">小学四年级</a-select-option>
                  <a-select-option value="小学五年级">小学五年级</a-select-option>
                  <a-select-option value="小学六年级">小学六年级</a-select-option>
                  <a-select-option value="初中一年级">初中一年级</a-select-option>
                  <a-select-option value="初中二年级">初中二年级</a-select-option>
                  <a-select-option value="初中三年级">初中三年级</a-select-option>
                  <a-select-option value="高中一年级">高中一年级</a-select-option>
                  <a-select-option value="高中二年级">高中二年级</a-select-option>
                  <a-select-option value="高中三年级">高中三年级</a-select-option>
                  <a-select-option value="大学">大学</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="家长文化" prop="parent.parent_culture">
                  <a-select placeholder="请选择" v-model="formModel.parent.parent_culture">  
                    <a-select-option value="文盲">文盲</a-select-option>
                    <a-select-option value="小学毕业">小学毕业</a-select-option>
                    <a-select-option value="初中毕业">初中毕业</a-select-option>
                    <a-select-option value="高中毕业">高中毕业</a-select-option>
                    <a-select-option value="本科毕业">本科毕业</a-select-option>
                    <a-select-option value="专科毕业">专科毕业</a-select-option>
                    <a-select-option value="硕士毕业">硕士毕业</a-select-option>
                    <a-select-option value="博士毕业">博士毕业</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
          </a-row>
          <div class="line1"></div>
          <div v-if="detailScoreAvailable || existingDetailed" class="detail-score-switch">
            <div>
              <div class="detail-score-switch-title">详细分数录入</div>
              <div class="detail-score-switch-state">{{ detailScoreMode ? '已开启' : '手工录入' }}</div>
            </div>
            <a-switch
              :checked="detailScoreMode"
              :disabled="existingDetailed && !detailScoreAvailable"
              @change="handleDetailScoreModeChange"
            />
          </div>
          <abas-score-detail
            v-if="detailScoreMode"
            v-model="formModel.parent.detail_scores"
            edition="2"
            scoring-type="1"
            @totals-change="applyDetailTotals"
          />
          <a-row>
            <a-col :span="13">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="沟通" prop="parent.score_communicate">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_communicate" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="社区应用" prop="parent.score_community">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_community" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="学习功能" prop="parent.score_study">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_study" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="居家生活" prop="parent.score_family">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_family" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="健康与安全" prop="parent.score_healthy">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_healthy" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="休闲" prop="parent.score_leisure">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_leisure" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="自我照顾" prop="parent.score_self_care">
                    <div class="flex">
                      <a-input-number class="cu-input1 input-number-100" :disabled="detailScoreMode" :min="0" :max="72" v-model="formModel.parent.score_self_care"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="自我管理" prop="parent.score_self_guidance">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_self_guidance" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="社交" prop="parent.score_social">
                    <div class="flex">
                      <a-input-number v-model="formModel.parent.score_social" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>

                </a-col>
              </a-row>
            </a-col>
            <a-col :span="11" class="right-box" style="padding-left: 40px">
              <a-row>
                <a-col>
                  <div class="right-title">比较类型</div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="置信区间" prop="parent.confidence_probability">
                    <a-select v-model="formModel.parent.confidence_probability" placeholder="请选择" style="width: 260px;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="统计显著性水平" prop="parent.significance_level">
                    <a-select v-model="formModel.parent.significance_level" placeholder="请选择(强项/弱项)" style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="0.05">0.05</a-select-option>
                      <a-select-option value="0.15">0.15</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 30px;margin-top: 20px"></div>
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="是否添加教师评-儿童版">
                <div class="flex">
                  <a-select v-model="isUnit" dropdownClassName="cu-select">
                    <a-select-option :value="1">否</a-select-option>
                    <a-select-option :value="2">是</a-select-option>
                  </a-select>
                  <div v-if="isUnit == 2" class="btn"
                       style="margin-left: 20px;cursor: pointer;padding: 0 20px;width: 150px" @click="openBindList">
                    关联教师评
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div v-if="isUnit == 2">
            <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
            <a-row>
            <a-col :span="13">
              <a-form-model-item label="所在学校">
                <a-input class="cu-input1" v-model="formModel.teacher.school_name"/>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="测试日期" prop="teacher.test_date">
                  <a-date-picker style="width: 100%" @change="changeTeachTestTime" format="YYYY-MM-DD" v-model="formModel.teacher.test_date"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="学校类别" prop="teacher.school_category">
                  <a-select placeholder="请选择" v-model="formModel.teacher.school_category">
                    <a-select-option value="无">无</a-select-option>
                    <a-select-option value="普通高等学校">普通高等学校</a-select-option>
                    <a-select-option value="中等专业学校（中专）">中等专业学校（中专）</a-select-option>
                    <a-select-option value="职业高中（职高）">职业高中（职高）</a-select-option>
                    <a-select-option value="技工学校（技校）">技工学校（技校）</a-select-option>
                  </a-select>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="实际年龄" prop="teacher.real_age">
                  <a-input class="cu-input1" disabled placeholder="选择测试日期后将自动计算" v-model="formModel.teacher.real_age"/>
                </a-form-model-item>
              </a-col>
          </a-row>
          <a-row>
            <a-col :span="13">
              <a-form-model-item label="所在年级" prop="teacher.grade">
                <a-select placeholder="请选择" v-model="formModel.teacher.grade">
                  <a-select-option value="无">无</a-select-option>
                  <a-select-option value="幼儿园大班">幼儿园大班</a-select-option>
                  <a-select-option value="小学一年级">小学一年级</a-select-option>
                  <a-select-option value="小学二年级">小学二年级</a-select-option>
                  <a-select-option value="小学三年级">小学三年级</a-select-option>
                  <a-select-option value="小学四年级">小学四年级</a-select-option>
                  <a-select-option value="小学五年级">小学五年级</a-select-option>
                  <a-select-option value="小学六年级">小学六年级</a-select-option>
                  <a-select-option value="初中一年级">初中一年级</a-select-option>
                  <a-select-option value="初中二年级">初中二年级</a-select-option>
                  <a-select-option value="初中三年级">初中三年级</a-select-option>
                  <a-select-option value="高中一年级">高中一年级</a-select-option>
                  <a-select-option value="高中二年级">高中二年级</a-select-option>
                  <a-select-option value="高中三年级">高中三年级</a-select-option>
                  <a-select-option value="大学">大学</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
              <a-col :span="11">
                <a-form-model-item label="家长文化" prop="teacher.parent_culture">
                  <a-select placeholder="请选择" v-model="formModel.teacher.parent_culture">
                    <a-select-option value="文盲">文盲</a-select-option>
                    <a-select-option value="小学毕业">小学毕业</a-select-option>
                    <a-select-option value="初中毕业">初中毕业</a-select-option>
                    <a-select-option value="高中毕业">高中毕业</a-select-option>
                    <a-select-option value="本科毕业">本科毕业</a-select-option>
                    <a-select-option value="专科毕业">专科毕业</a-select-option>
                    <a-select-option value="硕士毕业">硕士毕业</a-select-option>
                    <a-select-option value="博士毕业">博士毕业</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
          </a-row>
          <div class="line1"></div>
          <a-row>
            <a-col :span="13">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="沟通" prop="teacher.score_communicate">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_communicate" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="社区应用" prop="teacher.score_community">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_community" class="cu-input1 input-number-100" :min="0" :max="57"/>
                      <span class="num-de"><0-57></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="学习功能" prop="teacher.score_study">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_study" class="cu-input1 input-number-100" :min="0" :max="72"/>
                      <span class="num-de"><0-72></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="学校生活" prop="teacher.score_family">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_family" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="健康与安全" prop="teacher.score_healthy">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_healthy" class="cu-input1 input-number-100" :min="0" :max="63"/>
                      <span class="num-de"><0-63></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="休闲" prop="teacher.score_leisure">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_leisure" class="cu-input1 input-number-100" :min="0" :max="66"/>
                      <span class="num-de"><0-66></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="自我照顾" prop="teacher.score_self_care">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_self_care" class="cu-input1 input-number-100" :min="0" :max="51"/>
                      <span class="num-de"><0-51></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="自我管理" prop="teacher.score_self_guidance">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_self_guidance"  class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="社交"  prop="teacher.score_social">
                    <div class="flex">
                      <a-input-number v-model="formModel.teacher.score_social" class="cu-input1 input-number-100" :min="0" :max="69"/>
                      <span class="num-de"><0-69></span></div>
                  </a-form-model-item>

                </a-col>
              </a-row>
            </a-col>
            <a-col :span="11" class="right-box" style="padding-left: 40px">
              <a-row>
                <a-col>
                  <div class="right-title">比较类型</div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="置信区间" prop="teacher.confidence_probability">
                    <a-select v-model="formModel.teacher.confidence_probability" placeholder="请选择" style="width: 260px;height: 42px !important;line-height: 42px !important;;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="统计显著性水平" prop="teacher.significance_level">
                    <a-select v-model="formModel.teacher.significance_level" placeholder="请选择(强项/弱项)" style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="0.05">0.05</a-select-option>
                      <a-select-option value="0.15">0.15</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          </div>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center">
            <div class="btn sh" @click="goSelectAge"><img src="/images/btn-left-icon.png" alt="" style="height: 12px;margin-right: 5px"><span>返回选择页面</span></div>
            <div class="btn" style="margin-left: 20px" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>

          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
        <bind-list @changeBindList="changeBindList" :type="'detail'" :name="formModel.base.name"
               :gender="formModel.base.gender" :born_time="formModel.base.born_time" :edition="2" :scoring_type="1"
               :is-visible="bindListVisible"></bind-list>
  </div>
</template>

<script>
import {Save, Detail, Update, GetDetailScoreFeature} from '../../commonApi';
import {base, parent, teacher, formRulesParent, formRulesTeacher,} from "../children-field";
import {message} from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";
import AbasScoreDetail from "../../components/abas-score-detail";

export default {
  components: {AbasScoreDetail},
  data() {
    return {
      labelCol: {span: 8, style: {color: '#7E8589', fontWeight: '500'}},
      wrapperCol: {span: 14},
      formModel: {
        base: Object.assign({}, base),
        parent: Object.assign({}, parent),
        teacher: Object.assign({}, teacher)
      },
      formRules: Object.assign({}, {...formRulesParent, ...formRulesTeacher}),
      isUnit: 1, // 是否关联
      bindListVisible: false,
      id: '',
      detailScoreAvailable: false,
      detailScoreMode: false,
      existingDetailed: false
    }
  },
  mounted() {
    this.loadDetailScoreFeature();
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail()
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
  },
  methods: {
    async getDetail() {
      const res = await Detail({id: this.id});
      if (res && res.code == 0) {
        const detailScoreMode = String(res.adaptiveAssessment.detail_score_enabled) === '1';
        this.detailScoreMode = detailScoreMode;
        this.existingDetailed = detailScoreMode;
        this.formModel.parent = Object.assign({}, parent, res.adaptiveAssessment, {
          detail_scores: res.adaptiveAssessment.detail_scores || {},
        });
        this.formModel.base = {
            archives_num: res.adaptiveAssessment.archives_num,
            scoring_num: res.adaptiveAssessment.scoring_num,
            name: res.adaptiveAssessment.name,
            examiner_name: res.adaptiveAssessment.examiner_name,
            gender: res.adaptiveAssessment.gender,
            is_minorities : res.adaptiveAssessment.is_minorities,
            hand_habit: res.adaptiveAssessment.hand_habit,
            exam_address: res.adaptiveAssessment.exam_address,
            born_time : res.adaptiveAssessment.born_time,
            remark: res.adaptiveAssessment.remark,
          };
        if (res && res.otherAdaptiveAssessment) {
          this.isUnit = 2;
          this.formModel.teacher = Object.assign({}, res.otherAdaptiveAssessment);
          
        }
      }
    },
    async loadDetailScoreFeature() {
      const res = await GetDetailScoreFeature();
      if (res && res.code == 0) {
        this.detailScoreAvailable = Boolean(res.enabled);
      }
    },
    handleDetailScoreModeChange(checked) {
      this.detailScoreMode = checked;
      this.formModel.parent.detail_score_enabled = checked ? '1' : '0';
    },
    applyDetailTotals(totals) {
      if (!this.detailScoreMode) return;
      Object.keys(totals).forEach((key) => {
        this.$set(this.formModel.parent, key, totals[key]);
      });
    },
    goSelectAge() {
      this.$router.push({path: '/select-age'})
    },
    changeBornTimeParent(e, s) {
      if (s) {
        this.formModel.parent.test_date = s;
      } else {
        this.formModel.parent.test_date = ''
      }
    },
    changeBornTimeTeacher(e, s) {
      if (s) {
        this.formModel.teacher.test_date = s;
      } else {
        this.formModel.teacher.test_date = ''
      }
    },
    async actionData() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.isUnit == 1) {
            this.formModel.teacher = {};
          }
          let res = null;
          if (this.id) {
            res  = await Update(this.formModel);
          } else {
            res  = await Save(this.formModel);

          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({ content: res.message});
            setTimeout(()=> {
              this.$router.push({ path: "/" });
            }, 1500);
          }
        } else {
          message.error({ content: '表单验证未通过'});
        }
      });
    },
    openBindList() {
      this.bindListVisible = true;
    },
    changeBindList(e) {
      if (e.type == 'cancel') {
        this.bindListVisible = false;
      } else if (e.type == 'select') {
        this.bindListVisible = false;
        this.formModel.teacher = Object.assign({}, e.data);
      }
    },
    async getRealAge(type, time) {
      const res = await Api.GetRealAge({born_time: this.formModel.base.born_time, test_date: time});
      if (res && res.code == 0) {
        if (type == 'teacher') {
          this.formModel.teacher.real_age = res.realAge;
        } else {
          this.formModel.parent.real_age = res.realAge;
        }
      }
    },
    changeTeachTestTime(e,s) {
      if (s) {
        this.formModel.teacher.test_date = s;
        this.getRealAge('teacher', s);
      }
      else {
        this.formModel.teacher.real_age = ''
      }
    },
    changeParentTestTime(e,s) {
      if (s) {
        this.formModel.parent.test_date = s;
        this.getRealAge('parent', s);
      }
      else {
        this.formModel.parent.real_age = ''
      }
    }
  }
};
</script>
<style>

</style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}
.detail-score-switch {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0 0;
  padding: 0 18px;
  border: 1px solid #eadfea;
  border-radius: 6px;
  background: #faf7fa;
}
.detail-score-switch-title {
  color: #3e4144;
  font-size: 14px;
  font-weight: 600;
}
.detail-score-switch-state {
  margin-top: 3px;
  color: #999;
  font-size: 12px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}
.flex {
  display: flex;
}
.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  height: 460px;
  border-left: 1px solid #eee;
  padding-left: 70px;
  justify-content: center;
}
.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}
.cu-select{
  line-height: 42px;
  height: 42px;
}
.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}
.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}
.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
